// Plan, Payment State, Payment Source, Search
import { useState } from "react";
import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField, SelectChangeEvent, Grid2 } from "@mui/material";
import { FilterList, FilterListOff } from "@mui/icons-material";

import TransactionStyle from "./style";

import { usePlansList } from "@/api/hooks/usePlans";

export const defaultValues = {
    plan: "",
    search: "",
    status: "",
    source: "",
    method: "",
};

// eslint-disable-next-line no-unused-vars
export default function TransactionFilter({ onApply }: { onApply: (data: typeof defaultValues) => void }) {
    const [fields, setFields] = useState(defaultValues);
    const [filterActivated, setFilterActivated] = useState<boolean>(false);

    const { data: PlansData } = usePlansList({});
    const PlansList = PlansData?.data?.items || [];

    const toggleFilters = () => setFilterActivated((prev) => !prev);

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter" && fields.search !== "") {
            if (onApply) onApply(defaultValues);
        }
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | SelectChangeEvent) => {
        const name = event.target.name;
        const value = event.target.value;

        setFields((prev) => {
            return {
                ...prev,
                [name]: value,
            };
        });
    };

    const handleReset = () => {
        setFields(defaultValues);
        if (onApply) onApply(defaultValues);
    };

    const handleApply = () => onApply && onApply(fields);

    return (
        <TransactionStyle>
            <Box>
                <Button
                    startIcon={filterActivated ? <FilterListOff /> : <FilterList />}
                    type="button"
                    variant="contained"
                    onClick={toggleFilters}
                >
                    Filters
                </Button>
            </Box>
            <br />
            <Box className="filter-wrapper">
                {filterActivated && (
                    <>
                        <Box className="filter-fields-wrapper">
                            <Grid2 container spacing={2}>
                                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                                    <TextField
                                        fullWidth
                                        className="input field "
                                        label="Search"
                                        name="search"
                                        placeholder="Enter some text"
                                        size="small"
                                        value={fields.search}
                                        onChange={handleChange}
                                        onKeyDown={handleKeyDown}
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                                    <FormControl fullWidth className="select field" size="small">
                                        <InputLabel id="select-label">Payment State</InputLabel>
                                        <Select
                                            fullWidth
                                            id="select"
                                            label="Payment State"
                                            labelId="select-label"
                                            name="status"
                                            value={String(fields.status)}
                                            onChange={handleChange}
                                        >
                                            <MenuItem value={null as any}>None</MenuItem>
                                            <MenuItem value="FAILED">Failed</MenuItem>
                                            <MenuItem value="PENDING">Pending</MenuItem>
                                            <MenuItem value="SUCCESS">Successful</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                                    <FormControl fullWidth className="select field" size="small">
                                        <InputLabel id="source-select-label">Payment Source</InputLabel>
                                        <Select
                                            fullWidth
                                            id="source-select"
                                            label="Payment Source"
                                            labelId="source-select-label"
                                            name="source"
                                            value={String(fields.source)}
                                            onChange={handleChange}
                                        >
                                            <MenuItem value="">None</MenuItem>
                                            <MenuItem value="TAP">Website</MenuItem>
                                            <MenuItem value="PLAY_STORE">Google Play</MenuItem>
                                            <MenuItem value="APP_STORE">App Store</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                                    <FormControl fullWidth className="select field" size="small">
                                        <InputLabel id="method-select-label">Payment Method</InputLabel>
                                        <Select
                                            fullWidth
                                            id="method-select"
                                            label="Payment Method"
                                            labelId="method-select-label"
                                            name="method"
                                            value={String(fields.method)}
                                            onChange={handleChange}
                                        >
                                            <MenuItem value="">None</MenuItem>
                                            <MenuItem value="IOS_MOBILE_PAYMENT">App Store Pay</MenuItem>
                                            <MenuItem value="ANDROID_MOBILE_PAYMENT">Play Store Pay</MenuItem>
                                            <MenuItem value="VISA">Visa</MenuItem>
                                            <MenuItem value="MASTERCARD">Master Card</MenuItem>
                                            <MenuItem value="DISCOVER">Discover</MenuItem>
                                            <MenuItem value="JCB">Jcb</MenuItem>
                                            <MenuItem value="DINERS_CLUB">Diners Club</MenuItem>
                                            <MenuItem value="BENEFIT">Benefit</MenuItem>
                                            <MenuItem value="KNET">Knet</MenuItem>
                                            <MenuItem value="SADAD">Sadad</MenuItem>
                                            <MenuItem value="FAWRY">Fawry</MenuItem>
                                            <MenuItem value="OMANNET">Oman Net</MenuItem>
                                            <MenuItem value="APPLE_PAY">Apple Pay Wallet</MenuItem>
                                            <MenuItem value="GOOGLE_PAY">Google Pay Wallet</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                                    <FormControl fullWidth className="select field" size="small">
                                        <InputLabel id="plan-select-label">Plan</InputLabel>
                                        <Select
                                            id="plan-select"
                                            label="Plan"
                                            labelId="plan-select-label"
                                            name="plan"
                                            value={String(fields.plan)}
                                            onChange={handleChange}
                                        >
                                            <MenuItem value={null as any}>None</MenuItem>
                                            {PlansList.map((item) => {
                                                return (
                                                    <MenuItem key={item.id} value={item.id}>
                                                        {item.ml_title["ar"]}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                                    <Grid2 container spacing={2}>
                                        <Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
                                            <Button
                                                fullWidth
                                                className="action-btn"
                                                variant="contained"
                                                onClick={handleApply}
                                            >
                                                Apply
                                            </Button>
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
                                            <Button
                                                fullWidth
                                                className="action-btn"
                                                variant="contained"
                                                onClick={handleReset}
                                            >
                                                reset
                                            </Button>
                                        </Grid2>
                                    </Grid2>
                                </Grid2>
                            </Grid2>
                        </Box>
                    </>
                )}
            </Box>
        </TransactionStyle>
    );
}
